<template>
  <div class="modal" id="TaskCheck" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="width: 440px">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">反馈内容</h4>
        </div>
        <div class="modal-body" style="padding-top: 0">
          <div class="field-show" v-for="field in fields" v-if="field.value">
            <label>{{ field.key }}</label>
            <div
              v-html="displayFieldValue(field)"
              @click="imgPreview($event)"
            ></div>
          </div>
        </div>
        <div class="flex-footer">
          <div
            v-if="task && task.status == 3 && inspector.id == currentUser.id"
          >
            <button @click="checkTask(1)" class="btn btn-info" type="button">
              检验通过
            </button>
            <button @click="checkTask(0)" class="btn btn-danger" type="button">
              检验不通过
            </button>
          </div>
          <div
            v-if="task && task.status == 3 && inspector.id != currentUser.id"
          >
            等待<b class="text-primary">{{ inspector.name }}</b
            >检验
          </div>
          <button data-dismiss="modal" class="btn btn-default" type="button">
            关闭
          </button>
        </div>
      </div>
    </div>

    <div
      id="imgPreview"
      v-show="previewImgShow"
      @click.stop="previewImgShow = false"
    >
      <div
        style="max-width: 85%; height: 600px; display: flex"
        @click.stop="previewImgShow = true"
      >
        <img :src="previewSrc" />
      </div>
    </div>
  </div>
</template>

<script>
import { checkTask } from '@/service/getData'
import { getStore } from '@/config/mUtils'
import store from '@/store/index'

export default {
  props: {
    task: {
      type: Object,
      default: null,
    },
    inspector: {
      type: Object,
      default: null,
    },
  },
  watch: {
    task: function (newv) {
      if (newv) {
        if (newv.field_value.value.length > 0) {
          this.fields = JSON.parse(newv.field_value.value)
        } else {
          this.fields = []
        }
      }
    },
  },
  data() {
    return {
      fields: [],
      currentUser: store.getters.currentUser,
      previewSrc: null,
      previewImgShow: false,
    }
  },
  methods: {
    displayFieldValue(field) {
      if (!field.value) return ''
      if (field.type == 8) {
        let imgs = field.value.split(',')
        let htmls = []
        imgs.map((item) => {
          htmls.push('<img src="' + item + '"/>')
        })
        return htmls.join('')
      } else if (field.type == 7) {
        let dates = field.value.split(',')
        return dates.join('至')
      } else {
        return field.value
      }
    },
    imgPreview(e) {
      if (e.target.tagName == 'IMG') {
        this.previewSrc = e.target.currentSrc
        this.$nextTick(() => {
          this.previewImgShow = true
        })
      }
    },
    async checkTask(checked) {
      let data = {
        task_id: this.task.id,
        checked: !!checked,
      }
      let res = await checkTask(data)
      if (res.code == 0) {
        $('#TaskCheck').modal('hide')
        this.$emit('handled', res.data)
      }
    },
  },
}
</script>

<style scoped>
.flex-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-top: 1px solid #e5e5e5;
}
.flex-footer .btn-info {
  margin-right: 10px;
}
#imgPreview {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100000;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
#imgPreview img {
  max-width: 100%;
  max-height: 100%;
}
</style>